import React, { useEffect } from 'react';
import Layout from '../components/Modular/Layout';
import Section from '../components/Modular/Section';
import Unit from '../components/Modular/Unit';
import { Card } from '../components/Card';
import Button from '../components/Button';
import { useQuery } from '../hooks/useQuery';
import { useVerifyEmailToken } from '../hooks/useVerifyEmailToken';
import { useSendVerificationEmail } from '../hooks/useSendEmail';
import { useAuth } from '../contexts/AuthProvider/AuthProvider';
import { AthenaCore } from 'athena-core';
import { Link } from 'react-router-dom';

export const VerifyEmailPage: React.FC = () => {
  const query = useQuery();
  const token = query.get('token');

  const { user, loading } = useAuth();

  const { signUpVerified, verifySignUpToken } = useVerifyEmailToken(token);
  verifySignUpToken();

  const { sendVerificationEmail, sent } = useSendVerificationEmail();

  const context = {
    section: {
      layout: 'grid',
      background: 'dark',
      justifyItems: 'center',
    },
    unit: {
      colSpan: '1',
      rowSpan: '1',
    },
  };

  return (
    <Layout
      layout="grid"
      gap="md"
      alignContent="center"
      justifyItems="center"
      background="dark"
      context={context}
    >
      <Section layout="grid" background="dark">
        <Card
          title="Verify Email"
          subtitle="Thank you for signing up. Please verify your email."
          className=""
          context=""
          footer={
            <Unit gap="sm" justifyContent="flex-left">
              <Link to="/">
                <Button variant="primary">Back To Home</Button>
              </Link>
            </Unit>
          }
        >
          <Unit layout="flex" justifyContent="flex-left">
            {!sent && user && !token && (
              <Button
                onClick={() => {
                  sendVerificationEmail(user?.email);
                }}
              >
                Send Verification Email
              </Button>
            )}
          </Unit>
        </Card>
      </Section>
    </Layout>
  );
};
